// AccountNotificationsSkeleton.jsx — mirrors the real notifications layout
import React from "react";
import "../../account.css";
import "../accountNotifications.css";
import "./accountNotificationsSkeleton.css";

const AccountNotificationsSkeleton = () => {
	return (
		<div className="ac-page">
			{Array.from({ length: 3 }).map((_, i) => (
				<div key={i} className="ac-card">
					<div className="ac-card-head">
						<div className="apn-skel-icon shimmer" />
						<div className="apn-skel-line shimmer w-40" />
					</div>

					<div className="ac-card-body is-flush">
						{Array.from({ length: 2 }).map((_, j) => (
							<div key={j} className="apn-skel-item">
								<div className="apn-skel-line shimmer w-60" />

								<div className="apn-skel-channels">
									<div className="apn-skel-channel shimmer" />
									<div className="apn-skel-channel shimmer" />
								</div>
							</div>
						))}
					</div>
				</div>
			))}
		</div>
	);
};

export default AccountNotificationsSkeleton;
